import { render, staticRenderFns } from "./CargoKanbanCardFixed.vue?vue&type=template&id=c2db83e8"
import script from "./CargoKanbanCardFixed.vue?vue&type=script&lang=js"
export * from "./CargoKanbanCardFixed.vue?vue&type=script&lang=js"
import style0 from "./CargoKanbanCardFixed.vue?vue&type=style&index=0&id=c2db83e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports